
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Wand2, Loader2 } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface BusinessNameFieldProps {
  businessName: string;
  businessNameError: string;
  isGeneratingName: boolean;
  onBusinessNameChange: (value: string) => void;
  onGenerateBusinessName: () => Promise<void>;
}

export const BusinessNameField = ({ 
  businessName, 
  businessNameError,
  isGeneratingName, 
  onBusinessNameChange, 
  onGenerateBusinessName 
}: BusinessNameFieldProps) => {
  const handleBusinessNameChange = (value: string) => {
    onBusinessNameChange(value);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="businessName" className="flex">
        Business Name <span className="text-red-500 ml-1">*</span>
      </Label>
      <div className="flex gap-2">
        <Input
          id="businessName"
          value={businessName}
          onChange={(e) => handleBusinessNameChange(e.target.value)}
          placeholder="Enter your business name"
          required
          className={businessNameError ? "border-red-500" : ""}
        />
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                type="button"
                variant="outline"
                onClick={onGenerateBusinessName}
                disabled={isGeneratingName}
              >
                {isGeneratingName ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <Wand2 className="w-4 h-4" />
                )}
              </Button>
            </TooltipTrigger>
            <TooltipContent side="top" className="bg-white p-3 shadow-lg rounded-lg border max-w-[200px] text-center">
              <p>Click to generate a creative business name using AI!</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      {businessNameError && (
        <p className="text-red-500 text-sm mt-1">{businessNameError}</p>
      )}
    </div>
  );
};
